import React from "react";
import { ParagraphMedium } from "baseui/typography";
import styled from "styled-components";

const StyledSupplementalQuestionPromptDiv = styled.div`
  display: flex;
  white-space: pre-wrap;
`;

const StyledParagraphMedium = styled(ParagraphMedium)`
  font-weight: 500;
  padding-right: 3px;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 700px;
`;

const StyledText = styled(ParagraphMedium)`
  color: ${({ theme }) => theme.colors.contentTertiary};
  margin-bottom: ${({ theme }) => theme.sizing.scale300};
  margin-top: 0;
  max-width: 700px;
`;

export const StyledOptionalText = styled.span`
  font-weight: ${({ theme }) => theme.typography.ParagraphMedium.fontWeight};
  color: ${({ theme }) => theme.colors.contentTertiary};
  margin-bottom: 0;
  display: inline;
`;

interface Props {
  supplementalQuestionPrompt: string | React.ReactNode;
  secondaryText?: string;
  optional: boolean;
  dataTest?: string;
}

const PromptWithSecondaryText = ({
  supplementalQuestionPrompt,
  secondaryText,
  optional,
  dataTest = "question-prompt-with-secondary-text",
}: Props) => {
  return (
    <div>
      <StyledSupplementalQuestionPromptDiv>
        <StyledParagraphMedium data-test={`${dataTest}-supplemental-question-prompt`}>
          {supplementalQuestionPrompt}{" "}
          {optional ? (
            <StyledOptionalText data-test={`${dataTest}-optional-tag`}>
              (Optional)
            </StyledOptionalText>
          ) : (
            ""
          )}
        </StyledParagraphMedium>
      </StyledSupplementalQuestionPromptDiv>
      {secondaryText && (
        <StyledText data-test={`${dataTest}-secondary-text`}>{secondaryText}</StyledText>
      )}
    </div>
  );
};

export default PromptWithSecondaryText;
